import type { ContainerModuleLoader } from '@wix/thunderbolt-ioc'
import { ServiceProviderSymbol } from '@wix/thunderbolt-symbols'
import { ModelUpdatesHandlersImplementor } from 'ds-feature-model-updates-invoker'
import { RendererConfigurationService } from './rendererConfigurationService'
import { RendererConfigurationSideEffects } from './rendererConfigurationSideEffects'

export const site: ContainerModuleLoader = (bind) => {
	bind(ServiceProviderSymbol).to(RendererConfigurationService)
}

export const editor: ContainerModuleLoader = (bind) => {
	site(bind)
	bind(ModelUpdatesHandlersImplementor).to(RendererConfigurationSideEffects)
}
